interface BlogPostingSchemaInput {
    title: string;
    description: string;
    url: string;
    imageUrl: string;
    datePublished: string;
    dateModified?: string;
    authorName: string;
}

const MONTH_TO_INDEX: Record<string, string> = {
    January: '01',
    February: '02',
    March: '03',
    April: '04',
    May: '05',
    June: '06',
    July: '07',
    August: '08',
    September: '09',
    October: '10',
    November: '11',
    December: '12',
};

/** Converts display dates like "October 23, 2024" to ISO 8601. */
export const parseBlogDisplayDate = (displayDate: string): string | undefined =>
{
    const match = displayDate.match(/^(\w+)\s+(\d{1,2}),\s+(\d{4})$/);
    if (!match)
    {
        return undefined;
    }

    const month = MONTH_TO_INDEX[match[1]];
    if (!month)
    {
        return undefined;
    }

    const day = match[2].padStart(2, '0');
    return `${match[3]}-${month}-${day}`;
};

export const buildBlogPostingSchema = ({
    title,
    description,
    url,
    imageUrl,
    datePublished,
    dateModified,
    authorName,
}: BlogPostingSchemaInput) =>
{
    const published = parseBlogDisplayDate(datePublished);
    if (!published)
    {
        return null;
    }

    const modified = dateModified ? parseBlogDisplayDate(dateModified) : published;

    return {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: title,
        description,
        url,
        image: imageUrl,
        datePublished: published,
        dateModified: modified ?? published,
        author: {
            '@type': 'Person',
            name: authorName,
        },
        publisher: {
            '@type': 'Organization',
            name: 'Speer Technologies',
            logo: {
                '@type': 'ImageObject',
                url: 'https://www.speer.io/logo.png',
            },
        },
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': url,
        },
    };
};
